import React from "react";
import { BsyWidget } from "../BsyWidget";
import "./index.css";

export default class BsySeparator extends BsyWidget {
  constructor(props) {
    super({
      ...props,
      baseCls: "bsy-separator",
    });
    this.value = props.value;
  }

  renderStyle = () => {
    const { lineStyle, labelStyle, lineColor, labelColor, labelHidden } =
      this.options;
    switch (lineStyle) {
      case "style1": {
        return (
          <div className={`sep-line ${lineStyle}`}>
            <div
              className="sep-label"
              style={{
                color: labelColor,
                backgroundColor: lineColor,
              }}
            >
              <span
                style={{ display: labelHidden ? "none" : "" }}
                dangerouslySetInnerHTML={{ __html: labelStyle }}
              />
            </div>
            <div className="sep-right">
              <div
                className="right-triangle"
                style={{ backgroundColor: lineColor }}
              />
              <div className="right-line" style={{ borderColor: lineColor }} />
              <div
                className="right-parallelogram1"
                style={{ backgroundColor: lineColor }}
              />
              <div
                className="right-parallelogram2"
                style={{ backgroundColor: lineColor }}
              />
              <div
                className="right-parallelogram3"
                style={{ backgroundColor: lineColor }}
              />
            </div>
          </div>
        );
      }
      case "style2": {
        return (
          <div className={`sep-line ${lineStyle}`}>
            <div className="sep-bg-wrapper">
              <div className="sep-bg" style={{ borderColor: lineColor }} />
            </div>
            <div
              className="sep-label"
              style={{
                color: labelColor,
                backgroundColor: lineColor,
              }}
            >
              <span
                style={{ display: labelHidden ? "none" : "" }}
                dangerouslySetInnerHTML={{ __html: labelStyle }}
              />
            </div>
          </div>
        );
      }
      case "style3": {
        return (
          <div className={`sep-line ${lineStyle}`}>
            <div className="sep-bg-wrapper">
              <div className="sep-bg" style={{ backgroundColor: lineColor }} />
            </div>
            <div
              className="sep-label"
              style={{
                color: labelColor,
                backgroundColor: lineColor,
              }}
            >
              <span
                style={{ display: labelHidden ? "none" : "" }}
                dangerouslySetInnerHTML={{ __html: labelStyle }}
              />
            </div>
          </div>
        );
      }
      case "style4": {
        return (
          <div className={`sep-line ${lineStyle}`}>
            <div className="sep-bg" style={{ backgroundColor: lineColor }} />
            <div className="sep-center">
              <div
                className="sep-label"
                style={{
                  color: labelColor,
                  backgroundColor: lineColor,
                }}
              >
                <span
                  style={{ display: labelHidden ? "none" : "" }}
                  dangerouslySetInnerHTML={{ __html: labelStyle }}
                />
              </div>
              <div
                className="left-triangle"
                style={{ backgroundColor: lineColor }}
              />
              <div
                className="left-border"
                style={{ backgroundColor: lineColor }}
              />
              <div
                className="right-triangle"
                style={{ backgroundColor: lineColor }}
              />
              <div
                className="right-border"
                style={{ backgroundColor: lineColor }}
              />
            </div>
          </div>
        );
      }
      case "style5": {
        return (
          <div className={`sep-line ${lineStyle}`}>
            <div className="left-wrapper">
              <div
                className="left-block"
                style={{ backgroundColor: lineColor }}
              />
              <div
                className="left-triangle"
                style={{ backgroundColor: lineColor }}
              />
              <div className="left-square" />
              <div className="left-line1" style={{ borderColor: lineColor }} />
              <div className="left-line2" style={{ borderColor: lineColor }} />
            </div>
            <div
              className="sep-label"
              style={{
                color: labelColor,
                backgroundColor: lineColor,
              }}
            >
              <span
                style={{ display: labelHidden ? "none" : "" }}
                dangerouslySetInnerHTML={{ __html: labelStyle }}
              />
            </div>
            <div className="right-wrapper">
              <div
                className="right-block"
                style={{ backgroundColor: lineColor }}
              />
              <div
                className="right-triangle"
                style={{ backgroundColor: lineColor }}
              />
              <div className="right-square" />
              <div className="right-line1" style={{ borderColor: lineColor }} />
              <div className="right-line2" style={{ borderColor: lineColor }} />
            </div>
          </div>
        );
      }
      default:
        return (
          <div
            className={`sep-line ${lineStyle || "default"}`}
            style={{
              borderColor: lineColor,
            }}
          />
        );
    }
  };

  render() {
    const { cssName, value } = this.options;
    return (
      <div
        className={cssName}
        style={{
          width: "100%",
        }}
      >
        {this.renderStyle()}
        <div
          className="bsy-subhtml"
          dangerouslySetInnerHTML={{ __html: value }}
        />
      </div>
    );
  }
}
